import { Link } from "gatsby"
import { css } from "@emotion/react"

import Logo from "../images/logo.inline.svg"
import { theme } from "../constants/theme"

const Header = ({ title, nav, base }) => {
  return (
    <div
      css={css`
        position: fixed;
        top: 0;
        z-index: 1000;
        height: 65px;
        width: 100%;
        background-color: white;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
      `}
    >
      <div
        css={css`
          margin: 0 auto;
          padding: 0 20px 0 20px;
          height: 100%;
          max-width: ${theme.size.laptopL};
          display: flex;
          align-items: center;
          box-sizing: border-box;

          @media ${theme.devices.max.laptopL} {
            max-width: ${theme.size.tablet};
          }
        `}
      >
        <Link
          css={css`
            height: 30px;
            width: 30px;
            border-bottom: none;
            &:hover {
              color: ${theme.colors.primary};
            }
            @media ${theme.devices.max.mobile} {
              height: 25px;
              width: 25px;
            }
        `}
          to={base || "/"}
        >
          <Logo
            css={css`
              height: 30px;
              width: 30px;
              border-radius: 4px;
              @media ${theme.devices.max.mobile} {
                height: 25px;
                width: 25px;
              }
            `}
          />
        </Link>
        <Link
          css={css`
            font-size: 20px;
            font-weight: 400;
            color: ${theme.colors.primary};
            padding: 8px 10px;
            border-bottom: none;
            &:hover {
              color: ${theme.colors.primary};
            }
            @media ${theme.devices.max.mobile} {
              font-size: 18px;
            }
          `}
          to={base || "/"}
        >
          {title ? title : `托特`}
        </Link>

        <div
          css={css`
            margin-left: 20px;
          `}
        >
          {nav &&
            nav.map(({ title, link }) => (
              <Link
                key={title}
                css={css`
                  font-size: 18px;
                  font-weight: 400;
                  color: ${theme.colors.primary700};
                  border-bottom: none;
                  &:hover {
                    color: ${theme.colors.primary500};
                  }
                  @media ${theme.devices.max.mobile} {
                    font-size: 16px;
                  }
                `}
                to={link}
              >
                {title}
              </Link>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Header
